import { fabric } from 'fabric'

export default function useInitFabricHistory(canvases) {
  canvases.forEach((canvas) => {
    if (!(canvas instanceof fabric.Canvas)) {
      throw new Error(
        'All elements in the array must be instances of fabric.Canvas.'
      )
    }

    canvas._historyInit = fabric.Canvas.prototype._historyInit
    canvas._historyDispose = fabric.Canvas.prototype._historyDispose
    canvas._historySaveAction = function () {
      if (this.historyProcessing) {
        return
      }

      const json = this.historyNextState
      this.historyUndo.push(json)
      this.historyNextState = this._historyNext()
      this.fire('history:append', { json })
    }
    canvas._historyNext = function () {
      return JSON.stringify(this.toDatalessJSON(this.extraProps))
    }
    canvas._historyEvents = function () {
      return {
        'object:added': this._historySaveAction,
        'object:removed': this._historySaveAction,
        'object:modified': this._historySaveAction,
        'object:skewing': this._historySaveAction,
        'object:changed': this._historySaveAction,
      }
    }

    canvas.historyUndo = []
    canvas.historyRedo = []
    canvas.historyNextState = ''

    canvas.on(canvas._historyEvents())
    canvas._historySaveAction()
  })

  /**
   * Override the initialize function for the _historyInit();
   */
  fabric.Canvas.prototype.initialize = (function (originalFn) {
    return function (...args) {
      originalFn.call(this, ...args)
      this._historyInit()
      return this
    }
  })(fabric.Canvas.prototype.initialize)

  /**
   * Override the dispose function for the _historyDispose();
   */
  fabric.Canvas.prototype.dispose = (function (originalFn) {
    return function (...args) {
      originalFn.call(this, ...args)
      // this._historyDispose();
      return this
    }
  })(fabric.Canvas.prototype.dispose)

  /**
   * Initialization of the plugin
   */
  fabric.Canvas.prototype._historyInit = function () {
    this.extraProps = [
      'selectable',
      'editable',
      'id',
      'objectType',
      'resolution',
      '_controlsVisibility',
      'originalSource',
    ]
    this.historyProcessing = false
    this.sel = null
  }

  /**
   * Remove the custom event listeners
   */
  fabric.Canvas.prototype._historyDispose = function () {
    // No need to remove listeners since we're using separate history for each canvas
  }

  /**
   * Undo to latest history.
   * Pop the latest state of the history. Re-render.
   * Also, pushes into redo history.
   */
  fabric.Canvas.prototype.undo = function (callback) {
    this.historyProcessing = true
    const history = this.historyUndo.pop()
    if (history) {
      this.historyRedo.push(this.historyNextState)
      this.historyNextState = history
      this._loadHistory(history, 'history:undo', callback)
    } else {
      this.historyProcessing = false
    }
  }

  /**
   * Redo to latest undo history.
   */
  fabric.Canvas.prototype.redo = function (callback) {
    this.historyProcessing = true
    const history = this.historyRedo.pop()
    if (history) {
      this.historyUndo.push(this.historyNextState)
      this.historyNextState = history
      this._loadHistory(history, 'history:redo', callback)
    } else {
      this.historyProcessing = false
    }
  }

  fabric.Canvas.prototype._loadHistory = function (history, event, callback) {
    const that = this

    this.loadFromJSON(history, function () {
      that.renderAll()
      that.fire(event)
      that.historyProcessing = false

      if (callback && typeof callback === 'function') {
        callback()
      }
    })
  }

  /**
   * Clear undo and redo history stacks
   */
  fabric.Canvas.prototype.clearHistory = function () {
    this.historyUndo = []
    this.historyRedo = []
    this.historyNextState = ''
    this.fire('history:clear')
  }

  /**
   * On the history
   */
  fabric.Canvas.prototype.onHistory = function () {
    this.historyProcessing = false
    this._historySaveAction()
  }

  /**
   * Off the history
   */
  fabric.Canvas.prototype.offHistory = function () {
    this.historyProcessing = true
  }
}
